module.exports = __webpack_public_path__ + "front/img/32.4f20ff32.png";